import { render, staticRenderFns } from "./forgot_password.vue?vue&type=template&id=f7a19742"
import script from "./forgot_password.vue?vue&type=script&lang=js"
export * from "./forgot_password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports